/**
 * @param {number}bytes
 * @param {number}fractionDigits
 *
 * @returns {string}
 * @copyright https://stackoverflow.com/a/14919494/11244543
 */
export function humanFileSize(bytes: number, fractionDigits = 1): string {
    const thresh = 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    const r = 10 ** fractionDigits;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


    return bytes.toFixed(fractionDigits) + ' ' + units[u];
}
